<template>
  <el-menu :collapse="isCollapsed" :router="true" :collapse-transition="false">
    <el-menu-item-group :title="$t('Menu')">
      <el-menu-item
        v-for="item in filteredItems"
        :index="item.name"
        :key="item.id"
        :route="item.link"
        :class="{ 'is-active--custom': $route.path.includes(item.name) }"
        @click="item.clickHandler"
      >
        <span slot="title" v-if="!item.children.length" v-html="$t(item.title)"></span>
        <i class="material-icons m-r-1" v-if="!item.children.length">{{ item.icon.name }}</i>

        <el-submenu index="1" v-if="item.children.length > 0">
          <template slot="title">
            <i class="material-icons m-r-1">{{ item.icon.name }}</i>
            <span slot="title">{{ item.title }}</span>
          </template>

          <el-menu-item v-for="child in item.children" :index="child.name" :key="child.id" :route="child.link" @click="child.clickHandler">
            <span slot="title">{{ child.title }}</span>
            <i class="material-icons m-r-1">{{ child.icon.name }}</i>
          </el-menu-item>
        </el-submenu>
      </el-menu-item>
    </el-menu-item-group>
  </el-menu>
</template>

<script>
import { mapGetters } from 'vuex';
import { DASHBOARD, PROJECTS } from '@/router/route-types';

export default {
  name: 'AppNavigationMain',

  computed: {
    ...mapGetters({
      isAdmin: `user/isAdmin`,
      isCollapsed: `menu/isCollapsed`
    }),

    filteredItems() {
      if (this.isAdmin) {
        return this.items;
      } else {
        return this.items.filter(item => {
          return item.role !== 'admin';
        });
      }
    }
  },

  data() {
    return {
      items: [
        {
          id: 1,
          title: 'Dashboard',
          name: 'dashboard',
          link: {
            name: DASHBOARD
          },
          icon: {
            name: 'dashboard'
          },
          clickHandler: function() {},
          children: [],
          role: 'member'
        },
        {
          id: 2,
          title: 'Personalized Templates',
          name: 'projects',
          link: {
            name: PROJECTS
          },
          icon: {
            name: 'book'
          },
          clickHandler: function() {},
          children: [],
          role: 'admin'
        }
      ]
    };
  }
};
</script>
